import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/utils/api";

// Async thunks
export const fetchDistricts = createAsyncThunk(
  "master/fetchDistricts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/master/districts");
      // return response.data.districts
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Fetch districts with assigned user details
export const fetchDistrictsWithAssignedDetails = createAsyncThunk(
  "master/fetchDistrictsWithAssignedDetails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/districts-assigned-details");
      // return response.data.districts
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchCommunities = createAsyncThunk(
  "master/fetchCommunities",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/master/communities");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchGenders = createAsyncThunk(
  "master/fetchGenders",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/master/genders");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchAllMasterData = createAsyncThunk(
  "master/fetchAllMasterData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/master-data");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const toggleDistrictStatus = createAsyncThunk(
  "master/toggleDistrictStatus",
  async (districtId, { rejectWithValue }) => {
    try {
      const response = await api.patch(
        `/districts/${districtId}/toggle-status`
      );
      return response.data.data; // returns updated district info
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const masterSlice = createSlice({
  name: "master",
  initialState: {
    districts: [],
    communities: [],
    genders: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch districts
      .addCase(fetchDistricts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDistricts.fulfilled, (state, action) => {
        state.loading = false;
        state.districts = action.payload;
      })
      .addCase(fetchDistricts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch districts";
      })
      // Fetch communities
      .addCase(fetchCommunities.fulfilled, (state, action) => {
        state.communities = action.payload;
      })
      // Fetch genders
      .addCase(fetchGenders.fulfilled, (state, action) => {
        state.genders = action.payload;
      })
      // Fetch all master data
      .addCase(fetchAllMasterData.fulfilled, (state, action) => {
        state.districts = action.payload.districts;
        state.communities = action.payload.communities;
        state.genders = action.payload.genders;
      })

      // Fetch districts with assigned details
      .addCase(fetchDistrictsWithAssignedDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDistrictsWithAssignedDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.districts = action.payload;
      })
      .addCase(fetchDistrictsWithAssignedDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Toggle district status
      .addCase(toggleDistrictStatus.fulfilled, (state, action) => {
        const updated = action.payload;
        state.districts = state.districts.map((district) =>
          district.id === updated.id
            ? {
                ...district,
                is_active: updated.is_active,
                status: updated.status,
              }
            : district
        );
      });
  },
});

export const { clearError } = masterSlice.actions;
export default masterSlice.reducer;
